import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { SelectItem } from 'primeng';
import { ErrorModel, PromiseResult, ServerError } from 'src/app/models/PromiseResult';
import { Specialty } from 'src/app/models/Speciality';
import { CountriesService } from 'src/app/services/countries.service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { SpecialityService } from 'src/app/services/speciality.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { MessagesEgdUserQuery } from '../../../models/Doctor';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@Component({
    selector: 'app-doctors-list',
    templateUrl: './doctors-list.component.html',
    styleUrls: ['./doctors-list.component.css']
})
@TraceClassDecorator()
export class DoctorsListComponent implements OnInit {

    @Input("multiple")
    multiple: boolean = null;
    @Output() doctorChange: EventEmitter<any> = new EventEmitter<any>();

    doctor_list: SelectItem[] = [];
    doctorsListing_response: PromiseResult;
    doctorsListing_error: ErrorModel;
    doctorsListing_serverError: ServerError = null;
    doctorsListing_posting: boolean;

    doctor_user_id: string;
    specialties: SelectItem[] = [];
    countries: SelectItem[] = [];
    is_filter: boolean = false;
    param = new MessagesEgdUserQuery();
    provider_id: string =  "";
    to_user_guid: string[] = [];
    constructor(
        private readonly doctorsService: DoctorsService,
        private readonly specialtyService: SpecialityService,
        private readonly countryService: CountriesService,
        private utitilitiesService:UtilitiesService,
        private readonly providerStateService: ProviderStateService
        ) { }

    async ngOnInit(): Promise<void> {
        this.doctor_user_id = sessionStorage.getItem('userid');
        this.provider_id = this.providerStateService.getProviderId();
        await this.ResetDoctorsListingeModels();
        this.doctorsListing_posting = false;
        await this.GetDoctors();
        this.param.is_doctor = true
    }

    private async ResetDoctorsListingeModels(): Promise<void> {
        this.doctorsListing_response = {
            success: null,
            error: null,
            data: null
        };
        this.doctorsListing_serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }
    async GetDoctors(): Promise<void> {
        await this.ResetDoctorsListingeModels();
        this.doctorsListing_posting = true;
        await this.doctorsService.findUserList(this.param).toPromise().then(async (result: PromiseResult) => {
            this.doctor_list = [];
            if (result.success) {
                const temp: SelectItem[] = [];
                temp.push({ label: "Select a doctor", value: null });
                for (let i = 0; i < result.data.length; i++) {
                        temp.push(
                            {
                                label: result.data[i].first_name + " " + (result.data[i].middle_name==null? '': result.data[i].middle_name) + " " + result.data[i].last_name +
                                    " (" + result.data[i].d_specialty_type.specialty_name + ", " + result.data[i].country.country_name + ")",
                                value: result.data[i].user_guid
                            }
                        )
                    
                }
                this.doctor_list = temp;
            }
            else {
                this.doctorsListing_response = result;
            }
            this.doctorsListing_posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.doctorsListing_serverError = error.error;
            this.doctorsListing_response.success = false;
            this.doctorsListing_posting = false;
        })
    }

    async CallCountryAndSpecialtyFn(): Promise<void> {
        this.to_user_guid = [];
        if (this.is_filter) {
            await this.FetchSpecialty();
            await this.FetchCountries();
        }
        else {
            this.param.country_id = null;
            this.param.specialty_id = null;
            await this.GetDoctors();
        }

    }
    private async FetchSpecialty(): Promise<void> {
        if (this.specialties.length == 0) {
            this.doctorsListing_posting = true;
            await this.specialtyService.GetAllSpecialities(undefined,this.provider_id).toPromise().then(result => {
                if (result.success) {
                    this.specialties = [
                        {
                            label: "None",
                            value: null
                        }
                    ]
                    let temp: Specialty[] = result.data;
                        temp.forEach(async iterator => {
                            this.specialties.push(
                                {
                                    label: (iterator.specialty_name),
                                    value: iterator.id
                                }
                            )
                        })
                }
            })
            this.doctorsListing_posting = false;
        }

    }

    private async FetchCountries(): Promise<void> {
        if (this.countries.length == 0) {
            this.doctorsListing_posting = true;
            await this.countryService.getCountries(this.provider_id).toPromise()
            .then(result => {
                this.countries = [
                    {
                        label: "None",
                        value: null
                    }
                ]
                for (const country of result) this.countries.push(
                    {
                        label: country.country_name,
                        value: country.id
                    }
                )

                this.doctorsListing_posting = false;
            })
        }

    }

    sendGuid() {
        // this.profileLinkAdded=false;
        // this.message.message="Zoom Link : \n"+this.zoom_link;
        // this.shareLink.resetProfileLink();

        this.doctorChange.emit(this.to_user_guid);

    }

}
